import { render } from "./PosCustomersTable.vue?vue&type=template&id=3bdf18ff&scoped=true&ts=true"
import script from "./PosCustomersTable.vue?vue&type=script&lang=ts"
export * from "./PosCustomersTable.vue?vue&type=script&lang=ts"

import "./PosCustomersTable.vue?vue&type=style&index=0&id=3bdf18ff&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bdf18ff"]])

export default __exports__